import React from 'react';
import { DropdownTemplate } from 'themes/components';

export default function Dropdown(props) {
	return <DropdownTemplate {...props} />;
}



// WEBPACK FOOTER //
// ./src/core/components/Dropdown.jsx